export enum EFilters {
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  LAST_WEEK = 'Week',
  LAST_MONTH = 'Month'
}
